import { Box, Flex, Select } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { FormField } from 'shared/components';
import { JobLangGroupItemModel } from './job-lang-group-item.model';
import { JobLang, JobLangSkill } from 'jobs/types';

const JobLangGroupItemView = ({
   model,
   action,
   required = false,
   lngOptions,
   lngSkillOptions,
}: {
   model: JobLangGroupItemModel;
   action: ReactNode;
   required?: boolean;
   lngOptions: JobLang[];
   lngSkillOptions: JobLangSkill[];
}) => {
   if (model.hidden) {
      return null;
   }

   return (
      <Flex gap="4" align="end" pr={required ? '0' : '100px'}>
         <FormField label="Знання мови">
            <Select.Root
               size="3"
               value={model.langFormControl.value}
               onValueChange={(value) => model.langFormControl.setValue(value)}
            >
               <Select.Trigger placeholder="Оберіть мову"></Select.Trigger>
               <Select.Content
                  color="blue"
                  position="popper"
                  onCloseAutoFocus={(e) => e.preventDefault()}
               >
                  <Box maxHeight="250px">
                     {lngOptions.map((lang) => {
                        return (
                           <Select.Item key={lang.id} value={lang.id.toString()}>
                              {lang.name}
                           </Select.Item>
                        );
                     })}
                  </Box>
               </Select.Content>
            </Select.Root>
         </FormField>

         <FormField label="Рівень володіння">
            <Select.Root
               size="3"
               value={model.langSkillFormControl.value}
               onValueChange={(value) => {
                  model.langSkillFormControl.setValue(value);
               }}
            >
               <Select.Trigger placeholder="Оберіть рівень володіння"></Select.Trigger>
               <Select.Content
                  color="blue"
                  position="popper"
                  onCloseAutoFocus={(e) => e.preventDefault()}
               >
                  <Box maxHeight="250px">
                     {lngSkillOptions.map((lang_skill) => {
                        return (
                           <Select.Item key={lang_skill.id} value={lang_skill.id.toString()}>
                              {lang_skill.name}
                           </Select.Item>
                        );
                     })}
                  </Box>
               </Select.Content>
            </Select.Root>
         </FormField>

         {action}
      </Flex>
   );
};

export const JobLangGroupItem = observer(JobLangGroupItemView);
